import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { OptionOrientation } from '../../Shared/Enums/optionOrientation';
import { GridSize } from '../../Shared/Enums/gridSize';

export default ({
  isReadOnlyView,
  optionOrientation,
  handleOptionOrientationChange,
  gridSize
}: {
  isReadOnlyView: boolean;
  optionOrientation: string;
  handleOptionOrientationChange: (event: SelectChangeEvent) => void;
  gridSize: GridSize;
}) => {
  return (
    <Stack>
      <FormControl disabled={isReadOnlyView}>
        <InputLabel>Option Orientation</InputLabel>
        <Select
          label="Option Orientation"
          value={optionOrientation}
          onChange={handleOptionOrientationChange}
          disabled={isReadOnlyView}
        >
          <MenuItem value={OptionOrientation.HORIZONTAL}>Horizontal</MenuItem>
          <MenuItem value={OptionOrientation.VERTICAL}>Vertical</MenuItem>
        </Select>
      </FormControl>
      {optionOrientation == '0' && gridSize < 6 ? (
        <h6>
          Horizontal orientation may not display as expected in grid sizes less
          than 1/2.
        </h6>
      ) : null}
    </Stack>
  );
};
